import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const HallOfFame = () => {
  const [years, setYears] = useState([]);
  const [winners, setWinners] = useState({});
  const [activeYear, setActiveYear] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchWinners = async (year, cache) => {
    if ((cache || winners)[year]) return;
    try {
      const res = await fetch(`${API_URL}/api/winners/year/${year}`);
      const data = await res.json();
      setWinners(prev => ({ ...prev, [year]: data }));
    } catch (err) {
      console.error('Failed to fetch winners:', err);
    }
  };

  useEffect(() => {
    const fetchYears = async () => {
      try {
        const res = await fetch(`${API_URL}/api/winners/years`);
        const data = await res.json();
        setYears(data);
        if (data.length > 0) {
          setActiveYear(data[0]);
          fetchWinners(data[0], {});
        }
      } catch (err) {
        console.error('Failed to fetch years:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchYears();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleYearClick = (year) => {
    setActiveYear(year);
    fetchWinners(year);
  };

  const currentWinners = winners[activeYear] || [];

  return (
    <div className="hall-of-fame-page" data-testid="hall-of-fame-page">
      <div className="hof-container">
        <h1 className="page-title">HALL OF FAME</h1>
        <p className="page-intro">Celebrating excellence in global finance across the years.</p>

        {loading ? (
          <div className="loading-state">Loading...</div>
        ) : (
          <>
            <div className="year-tabs" data-testid="year-tabs">
              {years.map(year => (
                <button
                  key={year}
                  className={`year-tab ${activeYear === year ? 'active' : ''}`}
                  onClick={() => handleYearClick(year)}
                  data-testid={`year-tab-${year}`}
                >
                  {year}
                </button>
              ))}
            </div>

            <div className="winners-grid" data-testid="winners-grid">
              {currentWinners.map((winner, idx) => (
                <Link
                  to={`/company/${winner.slug}`}
                  key={`${winner.slug}-${idx}`}
                  className="winner-card-link"
                  data-testid={`winner-card-${winner.slug}`}
                >
                  <div className="hof-winner-card">
                    <div className="hof-logo-wrap">
                      {winner.logo ? (
                        <img src={winner.logo} alt={winner.name} className="hof-logo" />
                      ) : (
                        <div className="hof-logo-placeholder">{winner.name?.charAt(0)}</div>
                      )}
                    </div>
                    <div className="hof-card-info">
                      <h3 className="hof-company-name">{winner.name}</h3>
                      <span className="hof-nomination">
                        {winner.award_count > 1
                          ? `${winner.award_count} Awards`
                          : winner.nomination}
                      </span>
                      <span className="hof-type">{winner.title}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>

            {currentWinners.length === 0 && !loading && (
              <div className="empty-state">No winners for {activeYear} yet.</div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default HallOfFame;
